import styled from "styled-components";

const JobCardWrapper = styled.div`
  border: 1px solid #ccc;
  background-color: #fff;
  padding: 1rem;
  border-radius: 1rem;
  box-shadow: 0px 13px 27px 11px rgba(0, 0, 0, 0.1);
  /* margin-bottom: 1rem; */

  .job__type__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }

  .job__type__header > p {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 700;
    background-color: var(--dark);
    padding: 4px 8px;
    border-radius: 4px;
    color: #fff;
  }

  > .job__summary {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-block: 1.5rem 0.5rem;
  }
  @media screen and (max-width: 540px) {
    padding-block: 8px;

    .save__for__later__text {
      display: none;
    }
    > .job__summary {
      flex-direction: column;
      margin-block: 6px 0rem;
      gap: 0px;
    }
  }

  .job__info__con {
    /* border: 2px solid red; */
  }

  .job__info__con > p:first-child {
    font-size: 24px;
    font-weight: 700;
  }
  .job__info__con > p:nth-child(2),
  .job__info__con > p:nth-child(3) {
    font-size: 18px;
  }

  .job__details__btn {
    width: 120px;
    background-color: #000;
    color: #fff;
    margin-left: auto;
  }
  .job__details__btn:hover {
    background-color: #414040;
  }

  @media screen and (max-width: 980px) {
    .job__info__con > p:first-child {
      font-size: 18px;
      line-height: 20px;
    }
  }
  @media screen and (max-width: 540px) {
    .card__footer {
      display: flex;
    }

    .job__info__con > p:nth-child(2),
    .job__info__con > p:nth-child(3) {
      font-size: 14px;
    }

    .job__details__btn {
      font-size: 14px;
    }
  }

  .links__container {
    /* border: 2px solid red; */
    width: fit-content;
    margin-left: auto;
    margin-top: 6px;
    display: flex;
    gap: 12px;
  }

  .link__btn__con {
    /* display: block; */
    margin: 8px 0 0 auto;
    border-bottom: 1px solid #000;
    padding-inline: 4px;
  }

  .link__style {
    font-size: 14px;
  }
`;

export default JobCardWrapper;
